export const SPORTS = [
  { id: "rugby", label: "Rugby", color: "#CCFF00" },
  { id: "football", label: "Football", color: "#3B82F6" },
  { id: "horse-racing", label: "Horse Racing", color: "#F59E0B" },
  { id: "basketball", label: "Basketball", color: "#F97316" },
  { id: "cricket", label: "Cricket", color: "#22D3EE" },
  { id: "arts", label: "Arts & Theatre", color: "#C084FC" },
];

export const TEAMS = [
  { id: "warriors", label: "Worcester Warriors", sport: "rugby" },
  { id: "wrfc", label: "Worcester RFC", sport: "rugby" },
  { id: "raiders", label: "Worcester Raiders FC", sport: "football" },
  { id: "worcester-city", label: "Worcester City FC", sport: "football" },
  { id: "worcestershire-ccc", label: "Worcestershire CCC", sport: "cricket" },
  { id: "worcester-racecourse", label: "Worcester Racecourse", sport: "horse-racing" },
  { id: "worcester-wolves", label: "Worcester Wolves", sport: "basketball" },
  { id: "swan-theatre", label: "Swan Theatre", sport: "arts" },
  { id: "huntingdon-hall", label: "Huntingdon Hall", sport: "arts" },
  { id: "worcester-rep", label: "Worcester Repertory Company", sport: "arts" },
];

export const sportLabel = (id) => SPORTS.find((s) => s.id === id)?.label || id;
export const teamLabel = (id) => TEAMS.find((t) => t.id === id)?.label || id;
export const sportColor = (id) => SPORTS.find((s) => s.id === id)?.color || "#A1A1AA";
